import React from 'react';
import * as ReactRouterDOM from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { Role } from '../../types';
import { supabase } from '../../services/supabaseClient';
import { OTP_ENABLED } from '../../config/otp';

import { devError } from '@/utils/devLog';
const { Navigate, Outlet } = ReactRouterDOM as any;

export const RequirePhoneVerified: React.FC = () => {
  const { user, loading } = useAuth();
  const [checking, setChecking] = React.useState(true);
  const [allowed, setAllowed] = React.useState(false);
  const [redirectToVerify, setRedirectToVerify] = React.useState(false);

  React.useEffect(() => {
    const check = async () => {
      if (loading) return;
      if (!user) {
        setAllowed(false);
        setChecking(false);
        return;
      }

      if (!OTP_ENABLED) {
        setAllowed(true);
        setChecking(false);
        return;
      }

      // On ne force la vérification téléphone que pour les clients
      if (user.role !== Role.CLIENT) {
        setAllowed(true);
        setChecking(false);
        return;
      }

      try {
        // Colonne réelle en BDD : « téléphone » (accent). select('telephone') ne la renvoie pas → redirection en boucle.
        const { data, error } = await supabase
          .from('profiles')
          .select('*')
          .eq('id', user.id)
          .maybeSingle();

        if (error) {
          devError('[RequirePhoneVerified] Error loading profile', error);
          setAllowed(false);
          setRedirectToVerify(true);
          setChecking(false);
          return;
        }

        const row = data as Record<string, unknown> | null;
        const phone =
          row && typeof row['téléphone'] === 'string'
            ? (row['téléphone'] as string).trim()
            : '';
        const phoneVerifiedAt = row?.phone_verified_at;

        // Comptes de test Google Play Store : accès direct sans OTP
        if (row?.is_play_store_test_account === true) {
          setAllowed(true);
          setChecking(false);
          return;
        }

        if (phone && phoneVerifiedAt) {
          setAllowed(true);
          setChecking(false);
          return;
        }

        setAllowed(false);
        setRedirectToVerify(true);
        setChecking(false);
      } catch (e) {
        devError('[RequirePhoneVerified] Unexpected error', e);
        setAllowed(false);
        setRedirectToVerify(true);
        setChecking(false);
      }
    };

    check();
  }, [user, loading]);

  if (checking) {
    return null;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (redirectToVerify) {
    return <Navigate to="/verify-phone" replace />;
  }

  if (!allowed) {
    return null;
  }

  return <Outlet />;
};

